import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import * as Hammer from 'hammerjs';
import { BookImage, BookImageType, BookPageType } from 'src/app/data/book';
import { GlobalVariables } from 'src/app/data/global-variables';
import { FloatingVisorComponent } from 'src/app/floating-visor/floating-visor.component';
import { AlertService } from 'src/app/services/alert.service';
import { BookService } from 'src/app/services/book.service';
import { Company, ConfigService } from 'src/app/services/config.service';
import { ImagesCacheService } from 'src/app/services/images-cache.service';
import { ReportService } from 'src/app/services/report.service';
import { StudiesService } from 'src/app/services/studies.service';
import { AnimationsComponent } from 'src/app/utils/animations/animations.component';
import { ShareStudyComponent } from 'src/app/utils/share-study/share-study.component';
import { environment } from 'src/environments/environment';
import { TourService } from 'src/app/services/tour.service';
import { Subscription } from 'rxjs';
import { DownloadModalMobileComponent } from 'src/app/utils/download-modal/download-modal-mobile/download-modal-mobile.component';
import { ShareStudyMobileComponent } from 'src/app/utils/share-study/share-study-mobile/share-study-mobile.component';
import { HeaderComponent } from 'src/app/header/header.component';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-book-pdf-flipbook-vertical',
  templateUrl: './book-pdf-flipbook-vertical.component.html',
  styleUrls: ['./book-pdf-flipbook-vertical.component.css']
})
export class BookPdfFlipbookVerticalComponent implements OnInit, AfterViewInit {
  @Input() token!: string;
  downloading: number | null = null;
  showSpinner = false;
  shownVisorTip = false;
  showWindowingTool: boolean = true
  ignoreOpenPreview: boolean = false
  previewSize: number = 600
  previewLeft: number = 10
  bodyScale = 1;
  flipbookLoaded: boolean = false
  caducityTime: Date | null = null;
  flipbookLoading: boolean = false

  visorOpen: boolean = false;

  @ViewChildren(FloatingVisorComponent) viewers!: QueryList<FloatingVisorComponent>;
  @ViewChild(AnimationsComponent) animations!: AnimationsComponent;
  @ViewChild(ShareStudyComponent) shareStudyModal!: ShareStudyComponent;
  @ViewChild(HeaderComponent) headerComponent!: HeaderComponent;

  //subscription: Subscription; // Observer para poder cambiar la visibilidad de componenetes desde el tour

  BookPageType = BookPageType;
  BookImageType = BookImageType

  company!: Company;
  public Company = Company;
  window = window;

  constructor(
    public tourService: TourService,
    public globalVariables: GlobalVariables,
    public bookService: BookService,
    public reportService: ReportService,
    private alertService: AlertService,
    public imagesService: ImagesCacheService,
    private configService: ConfigService,
    private changeDetectorRef: ChangeDetectorRef,
    private studiesService: StudiesService,
    private cookieService: CookieService,
  ) {


    /*this.subscription = this.tourService.observable$.subscribe((n) => {

      switch (n) {
        case 70:
          if (this.bookService.currentBook != null) {
            if (this.bookService.currentBook.pages[1].bookImages[0].dicomFile != null) {
              this.openPreview(this.bookService.currentBook.pages[1].bookImages[0]);
   
            }
          }
          break
      }
     
 
    })*/

  }


  ngAfterViewInit(): void {


    this.tourService.deleteAllSteps(20);

    console.log("TourMode activado¿? --> ", this.tourService.tourMode);
    if (this.tourService.tourMode == "always") {
      setTimeout(() => {
        this.tourService.initMobileTour();
        this.startVerticalMobileTour();
      }, 500);
    } else if (this.tourService.tourMode == "cookies") {
      if (!this.checkCookieTour()) {
        setTimeout(() => {
          this.tourService.initMobileTour();
          this.startVerticalMobileTour();
        }, 500);

      }
    } else if (this.tourService.tourMode == "basic") {
      if (!this.checkCookieTour()) {
        this.tourService.initMobileTour();
        this.headerComponent.isCollapsed = false; // Llamar al método para abrir el menú
        setTimeout(() => {
          this.headerComponent.startBasicTour();
        }, 500);

      }
    }
  }


  checkCookieTour(): boolean {

    if (this.cookieService.get('cookieTourVerticalMobile')) {
      console.log("Cookie movil vertical encontrada");
      return true;
    } else {
      console.log("Cookie movil vertical no encontrada, se procede a su creación");
      this.cookieService.set('cookieTourVerticalMobile', 'cookieTourVerticalMobile')
      return false;
    }
  }

  ngOnInit(): void {
    // Cuando el visor esté abierto, prevenir el botón atrás y cerrar el visor
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', event => {
      if (this.viewers.some(v => v.isOpen)) {
        this.viewers.forEach(v => v.hide());
        history.pushState(null, document.title, location.href);
      } else {
        history.back();
      }
    });

    if (this.bookService.currentBookWithReports != null) {
      setTimeout(() => {
        this.resizeBookVertical()
        document.getElementsByClassName('carousel-item')?.item(0)?.classList?.add('active');
      }, 300);
    }

    this.refreshCompany();
  }

  refreshCompany() {
    this.company = this.configService.company;
    if (this.company == Company.NOT_DEFINED) {
      setTimeout(() => {
        this.refreshCompany();
      }, 200);
    }
  }

  public loadBook() {
    // console.log("loadBook mobile")
    this.showSpinner = true;
    this.changeDetectorRef.detectChanges()
    this.bookService.loadBookByToken(this.token).then(() => {
      this.showSpinner = false;
      this.bookService.startLoadingBook();
      this.flipbookLoading = true;

      console.log(this.bookService.currentBookWithReports);

      setTimeout(() => {
        this.resizeBookVertical();
        if (this.isPageSmall) {
          //this.animations.showTurnScreenAnimation().then(() => this.animations.showFingerAnimation('vertical'));
        }
        this.flipbookLoaded = true
        // console.log("loadBook mobile")

        setTimeout(() => {
          this.resizeBookVertical()
          document.getElementsByClassName('carousel-item')?.item(0)?.classList?.add('active');
        }, 250);
        /*setTimeout(() => {
          this.resizeBookVertical()
          document.getElementsByClassName('carousel-item')?.item(0)?.classList?.add('active');
        }, 5000);*/
      }, 250);
    })

    this.bookService.checkExpiringTime(this.token).subscribe(time => {
      this.configService.getConfig().then(c => {
        this.caducityTime = new Date(time);
      })
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {

    this.animations.cancelAnimations();
    if (this.flipbookLoaded) {
      this.flipbookLoaded = false;
      // if (this.isPageSmall) {
      //   this.animations.showFingerAnimation('vertical');
      // }
    }

    this.resizeBookVertical();
  }

  public resizeBookVertical() {
    // console.log("resizeBookVertical")
    const pages = document.getElementsByClassName('carousel-item');
    console.log('pages', pages);

    // const activePage = document.querySelectorAll('.carousel-page.active');

    // // Primera vez que se carga
    // if (activePage.length == 0) {
    //   document.getElementsByClassName('carousel-item')?.item(0)?.classList?.add('active');
    //   document.getElementsByClassName('carousel-item')?.item(0)?.classList?.add('first');
    //   document.getElementsByClassName('carousel-item')?.item(document.getElementsByClassName('carousel-item')?.length - 1)?.classList?.add('last');
    // }

    if (pages != null && pages.length != 0) {
      for (let i = 0; i < pages.length; i++) {
        const p = pages.item(i) as HTMLDivElement;
        p.style.height = (window.innerWidth * 1.41428) + 'px';
      }
    }
  }

  public set setFipbookLoaded(loaded: boolean) {
    this.flipbookLoaded = loaded
  }

  public get isFlipbookLoaded() {
    return this.flipbookLoaded
  }

  get isPageSmall() {
    return this.globalVariables.isPageSmall;
  }

  isVerticalPageActive(i: number) {
    return document.getElementsByClassName('carousel-item')?.item(i)?.classList?.contains('active');
  }

  download() {
    // if (!environment.demo) {
    //   if (this.downloading == null) {
    //     this.downloading = 0;
    //     this.bookService.downloadStudy(this.bookService.currentBookWithReports.studyUIDs).subscribe(event => {
    //       if (event.type == HttpEventType.DownloadProgress) {
    //         const percentage = (event.loaded / event.total) * 100
    //         console.log('percentage: ', percentage);
    //         this.downloading = Math.round(percentage)
    //       }

    //       if (event.type == HttpEventType.Response) {
    //         saveAs(event.body, "dicomdir.zip");
    //         this.downloading = null;
    //       }
    //     })
    //   }
    // }
  }

  showMenu() {
    this.visorOpen = false;
  }

  sendMail(mail: string) {

    if (!environment.demo) {
      if(this.configService._systemConfig?.prpSlave){
        this.bookService.sendBookMailByPRP(mail, this.token).subscribe(res => {
          if(res){
            this.alertService.alert('Correo enviado');
          }else{
            this.alertService.alert('Ha ocurrido un error al enviar el correo');
          }
          
        });
      }else{
        this.bookService.sendNotifToMail(mail, this.token).subscribe(res => {
          this.alertService.alert('Correo enviado');
          // alert('Correo enviado')
        });
      }
      
    }
  }

  // checkAskForSerieImg() {
  //   const viewerToUse = this.viewers.first;
  //   let route = this.imagesService.getRouteByImageId(viewerToUse.currentImage);
  //   this.configService.surrounding_images.then(surrounding => {
  //     if (viewerToUse.loadedImages - (viewerToUse.currentIndex + 1) < surrounding) {
  //       const target = this.bookService.getMoreImages('after', route);
  //       if (!this.imagesService.isLoaded(target)) {
  //         // TODO No estoy seguro de si aquí vale usar el join
  //         viewerToUse.loadOneMoreImage(this.bookService.currentBookWithReports.studyUIDs.join(','), target)
  //       }
  //     }
  //     if (viewerToUse.currentIndex < surrounding) {
  //       const target = this.bookService.getMoreImages('before', route);
  //       if (!this.imagesService.isLoaded(target)) {
  //         // TODO No estoy seguro de si aquí vale usar el join
  //         viewerToUse.loadOneMoreImage(this.bookService.currentBookWithReports.studyUIDs.join(','), target)
  //       }
  //     }
  //   })
  // }

  hammerIt(elm: HTMLElement) {
    const hammertime = new Hammer(elm, {});
    hammertime.get('pinch').set({
      enable: true
    });
    var posX = 0,
      posY = 0,
      last_scale = 1,
      last_posX = 0,
      last_posY = 0,
      max_pos_x = 0,
      max_pos_y = 0,
      transform = "",
      el = elm;

    hammertime.on('doubletap pan pinch panend pinchend', (ev: HammerInput) => {
      if (this.isPageSmall) {
        const viewerToUse = this.viewers.first;
        if (!viewerToUse.isOpen) {
          if (ev.type == "doubletap") {
            transform =
              "translate3d(0, 0, 0) " +
              "scale3d(2, 2, 1) ";
            this.bodyScale = 2;
            last_scale = 2;
            try {
              if (window.getComputedStyle(el, null).getPropertyValue('-webkit-transform').toString() != "matrix(1, 0, 0, 1, 0, 0)") {
                transform =
                  "translate3d(0, 0, 0) " +
                  "scale3d(1, 1, 1) ";
                this.bodyScale = 1;
                last_scale = 1;
              }
            } catch (err) { }
            el.style.webkitTransform = transform;
            transform = "";
          }

          //pan    
          if (this.bodyScale != 1) {
            posX = last_posX + ev.deltaX;
            posY = last_posY + ev.deltaY;
            max_pos_x = Math.ceil((this.bodyScale - 1) * el.clientWidth / 2);
            max_pos_y = Math.ceil((this.bodyScale - 1) * el.clientHeight / 2);
            if (posX > max_pos_x) {
              posX = max_pos_x;
            }
            if (posX < -max_pos_x) {
              posX = -max_pos_x;
            }
            if (posY > max_pos_y) {
              posY = max_pos_y;
            }
            if (posY < -max_pos_y) {
              posY = -max_pos_y;
            }
          }

          //pinch
          if (ev.type == "pinch") {
            this.bodyScale = Math.max(.999, Math.min(last_scale * (ev.scale), 4));
          }
          if (ev.type == "pinchend") { last_scale = this.bodyScale; }

          //panend
          if (ev.type == "panend") {
            last_posX = posX < max_pos_x ? posX : max_pos_x;
            last_posY = posY < max_pos_y ? posY : max_pos_y;
          }

          if (this.bodyScale != 1) {
            transform =
              "translate3d(" + posX + "px," + posY + "px, 0) " +
              "scale3d(" + this.bodyScale + ", " + this.bodyScale + ", 1)";
          }

          if (transform) {
            el.style.webkitTransform = transform;
          }
        }
      }
    });
  }

  public refreshGestures() {
    const element = document.getElementById('book-container');
    if (element == null) {
      setTimeout(() => {
        this.refreshGestures();
      }, 200);
      return;
    }
    const hamm = new Hammer(element!);
    // const hamm = new Hammer(document.body);

    hamm.get('swipe').set({
      direction: Hammer.DIRECTION_ALL,
      threshold: 15,
      velocity: 0.7
    });
    hamm.on('swipe', (ev: HammerInput) => {
      console.log('swipe event - ', ev);
      if (ev.pointers.length > 1) return;
      const currentPage = $('.carousel')[0]?.getElementsByClassName('active')[0];
      if (currentPage != null) {
        if (this.bodyScale <= 1.1) {
          if (ev.deltaX > 0) {
            if (!currentPage.classList.contains('first'))
              ($('.carousel') as any).carousel('prev')
          } else {
            if (!currentPage.classList.contains('last'))
              ($('.carousel') as any).carousel('next')
          }
        }
      }
      // Hacerle play a los vídeos que haya en pantalla
      try {
        const videos = document.getElementsByClassName('multiframe-video')
        if (videos != null && videos.length > 0)
          for (let i = 0; i < videos.length; i++) {
            (videos.item(i) as HTMLVideoElement).play();
          }
      } catch (err) {
        console.error(err);
      }
    })

    this.hammerIt(document.body);
  }

  openPreview(image: BookImage, event?: any) {
    this.visorOpen = true;
    this.showWindowingTool = true
    if (this.ignoreOpenPreview) return

    document.body.style.transform = "translate3d(0, 0, 0) " + "scale3d(1, 1, 1) ";
    document.body.style.webkitTransform = "translate3d(0, 0, 0) " + "scale3d(1, 1, 1) ";

    // console.log('opening img: ', image);

    const viewerToUse = this.viewers.first;
    if (this.bookService.currentBookWithReports!.advancedVisor) {
      viewerToUse.activateAdvancedMode();
    }

    if (!this.isPageSmall) {
      // console.log(event);

      this.previewLeft = event.clientX - (this.previewSize / 2);
    }
    this.showSpinner = true;

    switch (image.type) {
      case BookImageType.SERIES:
        const serieImagesSeries = this.bookService.currentBookWithReports!.studyInfo.find(s =>
          s.files.some(f => f == image.dicomFile) ||
          s.files.some(f => f.split('\\')[f.split('\\').length - 1] == image.dicomFile) ||
          s.files.some(f => f.split('/')[f.split('/').length - 1] == image.dicomFile)
        );
        // const serieImagesSeries = this.bookService.currentBookWithReports.studyInfo.find(s => s.serie == image.seriesUID);
        console.log('serieImages', serieImagesSeries);

        const instancesSeries = serieImagesSeries!.files.map(img => {
          let filename = img.split('\\')[img.split('\\').length - 1];
          filename = filename.split('/')[filename.split('/').length - 1];
          console.log('filename', filename);
          const instanceUID = filename.substring(0, filename.length - 4)
          return instanceUID;
        });

        // TODO No estoy seguro de si aquí vale usar el join
        viewerToUse.loadSerie(this.bookService.currentBookWithReports!.studyUIDs.join(','), instancesSeries).then(() => {
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });

        // TODO No estoy seguro de si aquí vale usar el join
        // viewerToUse.loadImageFromRoute(this.bookService.currentBookWithReports.studyUIDs.join(','), image.dicomFile).then(() => {
        //   this.showSpinner = false;
        //   // TODO No estoy seguro de si aquí vale usar el join
        //   viewerToUse.loadComplementaryImages(this.bookService.currentBookWithReports.studyUIDs.join(','), image.dicomFile);
        // }).catch(error => {
        //   this.showSpinner = false;
        //   alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        // });
        break;
      case BookImageType.CINE:
        const serieImagesCine = this.bookService.currentBookWithReports!.studyInfo.find(s =>
          s.files.some(f => f == image.dicomFile) ||
          s.files.some(f => f.split('\\')[f.split('\\').length - 1] == image.dicomFile) ||
          s.files.some(f => f.split('/')[f.split('/').length - 1] == image.dicomFile)
        );
        // const serieImagesCine = this.bookService.currentBookWithReports.studyInfo.find(s => s.serie == image.seriesUID);
        console.log('serieImages', serieImagesCine);

        const instancesCine = serieImagesCine!.files.map(img => {
          let filename = img.split('\\')[img.split('\\').length - 1];
          filename = filename.split('/')[filename.split('/').length - 1];
          console.log('filename', filename);
          const instanceUID = filename.substring(0, filename.length - 4)
          return instanceUID;
        });

        // TODO No estoy seguro de si aquí vale usar el join
        viewerToUse.loadSerie(this.bookService.currentBookWithReports!.studyUIDs.join(','), instancesCine).then(() => {
          viewerToUse.playClip();
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });

        // // TODO No estoy seguro de si aquí vale usar el join
        // viewerToUse.loadImageFromRoute(this.bookService.currentBookWithReports.studyUIDs.join(','), image.dicomFile).then(() => {
        //   // TODO No estoy seguro de si aquí vale usar el join
        //   viewerToUse.loadComplementaryImages(this.bookService.currentBookWithReports.studyUIDs.join(','), image.dicomFile).then(res => {
        //     this.showSpinner = false;
        //     viewerToUse.playClip();
        //   }).catch(error => {
        //     this.showSpinner = false;
        //     alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        //   });
        // }).catch(error => {
        //   this.showSpinner = false;
        //   alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        // });
        break;
      case BookImageType.GRID:
        viewerToUse.setGrid(image.gridSettings!.grid.rows, image.gridSettings!.grid.columns);
        // TODO No estoy seguro de si aquí vale usar el join
        viewerToUse.loadGridImages(image.gridSettings!.grid, this.bookService.currentBookWithReports!.studyUIDs.join(','), image.gridSettings!.dicomFiles).then(res => {
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });
        break;
      case BookImageType.UNIQUE:
      default:
        let filename = image.dicomFile!.split('\\')[image.dicomFile!.split('\\').length - 1];
        filename = filename.split('/')[filename.split('/').length - 1];
        console.log('filename', filename);
        const instanceUID = filename.substring(0, filename.length - 4)
        viewerToUse.loadImage(this.bookService.currentBookWithReports!.studyUIDs.join(','), instanceUID).then(() => {
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });
        // TODO No estoy seguro de si aquí vale usar el join
        // viewerToUse.loadImageFromRoute(this.bookService.currentBookWithReports.studyUIDs.join(','), image.dicomFile).then(() => {
        //   this.showSpinner = false;
        // }).catch(error => {
        //   this.showSpinner = false;
        //   alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        // });
        break;
    }

    const myCarouselElement = document.querySelector('#bookCarousel');
    console.log('myCarouselElement', myCarouselElement);
    // @ts-ignore
    const carousel = new bootstrap.Carousel('#bookCarousel')
    // carousel.to(0)
    carousel.nextWhenVisible();
    // const carouselIndex = myCarouselElement
  }

  //openShareModal() {
  //  this.shareStudyModal.open);
  //}

  downloadReport() {
    this.studiesService.downloadReport(this.bookService.currentBookWithReports!.studyUIDs);
  }

  startVerticalMobileTour() {
    console.log("Añadiendo pasos del tour movil vertical");

    ($('.carousel') as any).carousel(0)

    this.tourService.guideTour.addSteps([

      {
        id: "btn-1",
        attachTo: {
          element: "#book-container > div",
          on: "bottom"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              //($('.carousel') as any).carousel(0)
              this.tourService.guideTour.cancel();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              ($('.carousel') as any).carousel(1)
              setTimeout(() => {
                this.tourService.guideTour.next();
              },100)
              
            }
          }
        ],
        //classes: "shepherd-text tour-mobile-container-vertical",
        text: "<p>Esta es la portada de tu Book digital</p>" +
          "<p>Podrás deslizar para pasar a la siguiente página</p>",
      },
      {
        id: "btn-2",
        attachTo: {
          element: "#book-container > div",
          on: "bottom"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              ($('.carousel') as any).carousel(0)
              this.tourService.guideTour.complete()
              //this.tourService.guideTour.cancel();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              ($('.carousel') as any).carousel(0)
              setTimeout(() => {
                this.tourService.guideTour.back();
              },100)
            }

          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              ($('.carousel') as any).carousel(2)
              setTimeout(() => {
                this.tourService.guideTour.next();
              },100)
            }
          }
        ],
        //classes: "shepherd-text tour-mobile-container-vertical",
        text: "<p>En la primera página tenemos el informe resultante del estudio<p>",

      },
      {
        id: "btn-3",
        attachTo: {
          element: '#bookCarousel > div > div:nth-child(3)',
          on: "bottom"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              ($('.carousel') as any).carousel(0)
              this.tourService.guideTour.cancel();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              ($('.carousel') as any).carousel(1)
              setTimeout(() => {
                this.tourService.guideTour.back();
              },100)
            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              ($('.carousel') as any).carousel(0)

              this.headerComponent.isCollapsed = false; // Llamar al método para abrir el menú
              setTimeout(() => {
                this.headerComponent.addVerticalMenuSteps(); // Agregar pasos adicionales en HeaderComponent
                this.tourService.guideTour.next();
              }, 300);



            }
          }
        ],
        //classes: "shepherd-text tour-mobile-container-vertical",
        text: "<p>En las siguiente páginas tendrás las imágenes del estudio.</p>" +
          "<p>Podrás pulsarlas para ampliarlas</p>",
      }

    ])

    console.log("Pasos añadidos, iniciando tour");
    setTimeout(() => {
      this.tourService.guideTour.start();
    },500)
  }



}
